import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import LeaderboardChart from './LeaderboardChart';
import DistributionHistogram from './DistributionHistogram';
import TeamDistributionChart from './TeamDistributionChart';
import EventDistributionChart from './EventDistributionChart';

const ChartsDashboard = ({ adjustedTeamsMap, eventsScores, eventsMap, teams, categoriesMap, divisionsMap, adjustedRows }) => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12} md={6}>
        <LeaderboardChart adjustedTeamsMap={adjustedTeamsMap} teams={teams} />
      </Grid2>

      <Grid2 xs={12} md={6}>
        <DistributionHistogram adjustedTeamsMap={adjustedTeamsMap} />
      </Grid2>

      <Grid2 xs={12}>
        <TeamDistributionChart eventsScores={eventsScores} adjustedTeamsMap={adjustedTeamsMap} />
      </Grid2>

      <Grid2 xs={12}>
        <EventDistributionChart eventsScores={eventsScores} categoriesMap={categoriesMap} />
      </Grid2>
    </Grid2>
  );
};

export default ChartsDashboard;
